import clsx from 'clsx';
import { useController, useFormContext } from 'react-hook-form';

import { Checkbox } from '../../../../../../common/ui/checkbox';
import { Container } from '../../../../../../common/ui/container';
import { Loader } from '../../../../../../common/ui/loader';
import { NoData } from '../../../../../../common/ui/no-data';
import { TPageForm } from '../../../../page-form/page-form';
import styles from './ai-image-form-item.module.scss';

interface IProductAirImageProps {
  index: number;
  onClick: () => void;
  inProgress: boolean;
}

const ProductAiImage = ({
  inProgress = false,
  index,
  onClick,
}: IProductAirImageProps) => {
  const { control } = useFormContext<TPageForm>();
  const productId = useController({
    control,
    name: `productAiImages.ids.${index}.product_id`,
  });
  const imageUrl = useController({
    control,
    name: `productAiImages.ids.${index}.ai_image_url`,
  });
  const title = useController({
    control,
    name: `productAiImages.ids.${index}.title`,
  });
  const regenerate = useController({
    control,
    name: `productAiImages.ids.${index}.regenerate`,
  });

  return <Container className={styles.root} withoutBorder>
    <Container className={clsx(styles.content, inProgress && styles.content__in_progress)}>
      <span className={styles.title}>{title.field.value}</span>
      <span className={styles.subtitle}>{productId.field.value}</span>
      <Checkbox
        ref={regenerate.field.ref}
        checked={regenerate.field.value}
        className={styles.checkbox}
        disabled={inProgress}
        name={regenerate.field.name}
        onChange={(e) => regenerate.field.onChange(e.target.checked)}
      >
        {imageUrl.field.value ? 'Regenerate Image' : 'Generate Image'}
      </Checkbox>

      {imageUrl.field.value ? <div className={styles.imgWrapper} onClick={onClick}>
        <img
          alt={`ai-${imageUrl.field.value ? productId.field.value : index}`}
          className={styles.image}
          src={imageUrl.field.value}
        />
        {' '}
      </div>
        : !inProgress && <NoData size="small">
          No image yet
        </NoData>}
    </Container>
    {inProgress && <Loader className={styles.loader}>Generation in process...</Loader>}
  </Container>;
};

export { ProductAiImage };
